import React, {useState} from 'react';
import PropTypes from 'prop-types';
import FormRow from './FormRow';
import FormRowHorizontal from './FormRowHorizontal';
import FormField from './FormField';
import FormSubmitButton from './FormSubmitButton';
import FormCancelButton from './FormCancelButton';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

const FieldMapForm = props => {

  let {
    fieldMap,
    readOnly,
    onBlur,
    onChange,
    onSubmit,
    onReset,
    loading,
  } = props;

  const createFormField= (formField) => {
    let options = !formField.formOptions?undefined:formField.formOptions.map(formOption => {
      return [formOption.value, formOption.label];
    });

    return (
      <FormField
        fieldName={formField.fieldName}
        fieldNameId={formField.fieldNameId}
        showLabel={formField.parentFieldNameId?true:false}
        layout={formField.parentFieldNameId?'horizontal':undefined}
        controlType={formField.controlType}
        constraint={formField.constraint}
        options={options}
        readOnly={readOnly || loading}
        errorId={formField.errorId}
        invalid={formField.invalid}
        value={formField.value}
        onBlur={onBlur}
        onChange={onChange}  />
    );
  };

  const renderFormFieldObjects = (objects) => {
    return (
      <Container fluid>
        <Row>
          {objects.map((object, index) => {
            return <Col key={index}>{object}</Col>
          })}
        </Row>
      </Container>
    )
  };

  const rows = () => {
    let fieldGroups = {};
    Object.keys(fieldMap).forEach((key, index) => {
      let formField = fieldMap[key];

      let fieldGroupId = formField.parentFieldName?formField.parentFieldName:formField.fieldName;
      if (!fieldGroups[fieldGroupId]) {
        fieldGroups[fieldGroupId] = [];
      }
      fieldGroups[fieldGroupId].push(formField);
    });

    return Object.keys(fieldGroups).map((key, index) => {
      let formFieldGroup = fieldGroups[key];

      let formFieldObjects = formFieldGroup.map(formField => {
        return createFormField(formField);
      });

      let firstFormField = formFieldGroup[0];
      let rowNameId = formFieldGroup.length == 1?firstFormField.fieldNameId:firstFormField.parentFieldNameId;

      let layout = firstFormField.layout;
      if (layout==='horizontal') {
      //   return (
      //     <FormRowHorizontal key={formField.fieldNameId} rowNameId={formField.fieldNameId} required={formField.required}>
      //       {formFieldObject}
      //     </FormRowHorizontal>
      //   )
      }

      return (
        <FormRow key={key} rowNameId={rowNameId} required={firstFormField.required} layout={layout}>
          {renderFormFieldObjects(formFieldObjects)}
        </FormRow>
      )
    })
  };

  return (
    <Container fluid="true" className="aw-form mb-5">
      {rows()}
      <FormRow>
      <Row>
        <Col className="d-flex justify-content-center pt-4 pb-4">
          <FormSubmitButton onClick={onSubmit} loading={loading} />
        </Col>
      </Row>
      <Row>
        <Col className="d-flex justify-content-center pt-4 pb-4">
          <FormCancelButton onClick={onReset} loading={loading} />
        </Col>
      </Row>
      </FormRow>
    </Container>
  )

};

FieldMapForm.propTypes = {
  fieldMap: PropTypes.any,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onReset: PropTypes.func,
};

export default FieldMapForm;
